import { Button, ICON_COLOR } from '@zep-us/zus';
import { PlayIcon, SquareStackIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';

/**
 * MobileGuestCTAButtons Props
 */
export interface MobileGuestCTAButtonsProps {
  onCopy: () => void;
  onEnter: () => void;
}

/**
 * MobileGuestCTAButtons - 모바일용 게스트 사용자 CTA 버튼
 *
 * @description
 * 모바일 하단 고정 영역에 최적화된 게스트용 CTA 버튼 그룹입니다.
 * 가로 배치로 공간 효율성을 높였습니다.
 *
 * @example
 * ```tsx
 * <MobileGuestCTAButtons
 *   onCopy={handleCopy}
 *   onEnter={handleEnter}
 * />
 * ```
 */
export const MobileGuestCTAButtons = ({
  onCopy,
  onEnter
}: MobileGuestCTAButtonsProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full gap-sm" data-sentry-component="MobileGuestCTAButtons" data-sentry-source-file="MobileGuestCTAButtons.tsx">
      <Button size="md" intent="gradient" variant="contained" onClick={onCopy} leftSlot={<SquareStackIcon size="sm" fill={ICON_COLOR.inverse} />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileGuestCTAButtons.tsx">
        {t('common:detail.saveToMyQuiz')}
      </Button>
      <Button size="md" intent="alternative" variant="contained" onClick={onEnter} leftSlot={<PlayIcon size="sm" fill={ICON_COLOR.strong} />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileGuestCTAButtons.tsx">
        {t('detail.cta.tutorial')}
      </Button>
    </div>;
};